var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-filter-badge"},[_c('div',{staticClass:"filter-badge"},[_vm._v("\n        "+_vm._s(_vm.filter.label)+"\n\n        "),_c('button',{staticClass:"close-button",on:{"click":_vm.handleRemove}},[_vm._v(_vm._s(_vm.translations.removeText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }